import React from 'react'

//Components
import { CModal } from "components";
import Buttonv1 from 'components/v1/Button';
//Assets
import { ReactComponent as CrossIcon } from "assets/cross.svg";

//Context
import { useTTCtx } from "pages/dashboard/e-reporting/TableTransaksi/TTCtx";
import { useERMethod } from "pages/dashboard/e-reporting/ERCtx";
import { useNavigate } from 'react-router-dom'


const ModalCreateListing = () => {
  const { setOpenModalCreateListing } = useTTCtx()
  const { setPage } = useERMethod()
  const navigate = useNavigate();


  //Function
  const onClose = () => { setOpenModalCreateListing(false) };
  const handleUploadListing = () => {
    navigate('/upload-listing?is_archived=true');
  };

  return (
    <CModal toggle={onClose} id="modal-filter-lt">

      <div className='modal-content'>
        <div className='close-wrapper'>
          <CrossIcon className='cursor-pointer' onClick={onClose} />
        </div>
        <div>
          <p className='text-lg mb-[24px] font-medium text-black-0 title'>Apakah anda perlu upload listing terlebih dahulu untuk laporan transaksi ini?</p>

          <div className='box-between btn-wrapper'>
            <Buttonv1 className="mr-4" text="Tidak" type="secondary" onClick={() => { setPage("form") }} />
            <Buttonv1 text="Upload Listing" onClick={handleUploadListing} />
          </div>
        </div>
      </div>
    </CModal>
  )
}

const Wrapper = ({ ...props }) => {
  const { openModalCreateListing } = useTTCtx()

  if (!openModalCreateListing) return null;
  return <ModalCreateListing {...props} />
}

export default Wrapper;